import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiUser, FiDollarSign, FiTarget } = FiIcons;

const UsersOverview = ({ users, clients }) => {
  const getUserStats = (userId) => {
    const userClients = clients.filter(c => c.userId === userId);
    const totalValue = userClients.reduce((sum, c) => sum + c.contractValue, 0);
    const totalCommissions = userClients.reduce((sum, c) => sum + (c.commission || 0), 0);
    const paidClients = userClients.filter(c => c.status === 'pagato' || c.status === 'commissionato').length;
    
    return {
      totalClients: userClients.length,
      totalValue,
      totalCommissions,
      conversionRate: userClients.length > 0 ? Math.round((paidClients / userClients.length) * 100) : 0
    };
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 }}
      className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6"
    >
      <h2 className="text-lg font-semibold text-gray-900 mb-6">Performance Team</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {users.map((user, index) => {
          const stats = getUserStats(user.id);
          
          return (
            <motion.div
              key={user.id}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              className="border border-gray-200 rounded-lg p-4"
            >
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center">
                  <SafeIcon icon={FiUser} className="text-emerald-600" />
                </div>
                <div>
                  <h3 className="font-medium text-gray-900">{user.name}</h3>
                  <p className="text-sm text-gray-500">{user.email}</p>
                </div>
              </div>
              
              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">Clienti</span>
                  <span className="font-medium">{stats.totalClients}</span>
                </div>
                
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">Valore Tot.</span>
                  <span className="font-medium">€{stats.totalValue.toLocaleString()}</span>
                </div>
                
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">Commissioni</span>
                  <span className="font-medium text-emerald-600">€{stats.totalCommissions.toLocaleString()}</span>
                </div>
                
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">Conversione</span>
                  <span className="font-medium">{stats.conversionRate}%</span>
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </motion.div>
  );
};

export default UsersOverview;